﻿/**
 * Centralized Route Definitions
 * Connect Source Architecture
 */

export interface AppRoute {
  readonly path: string;
  readonly name: string;
  readonly title: string;
  readonly isNavVisible: boolean;
  readonly isProtected?: boolean;
}

export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  CAREER_COACHING: '/career-coaching',
  BUSINESS_SOLUTIONS: '/business-solutions',
  CONTACT: '/contact',
  DIGITAL_PRODUCTS: '/digital-products',
  PRODUCT_ATS_RESUME: '/digital-products/ats-resume-master-kit',
  PRODUCT_LINKEDIN: '/digital-products/linkedin-profile-optimization-toolkit',
  PRODUCT_INTERVIEW_CRACKER: '/digital-products/interview-cracker-kit',
  PRODUCT_AI_TOOLKIT: '/digital-products/ai-job-search-toolkit',
  PRODUCT_JOB_SWITCH: '/digital-products/30-day-job-switch-blueprint',
  FREE_INTERVIEW_GUIDE: '/free-interview-guide',
  THANK_YOU: '/thank-you',
  CHECKOUT: '/checkout',
  PAYMENT_SUCCESS: '/payment-success',
  PAYMENT_FAILED: '/payment-failed',
  DOWNLOAD: '/download',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS: '/terms',
  REFUND_POLICY: '/refund-policy'
} as const;

export const ROUTE_DEFINITIONS: readonly AppRoute[] = [
  { path: ROUTES.HOME, name: 'Home', title: 'Connect Source — Career Transformation & HR Solutions', isNavVisible: true },
  { path: ROUTES.CAREER_COACHING, name: 'Career Coaching', title: 'Professional Career Coaching — Connect Source', isNavVisible: true },
  { path: ROUTES.DIGITAL_PRODUCTS, name: 'Digital Products', title: 'Career Accelerators & Toolkits — Connect Source', isNavVisible: true },
  { path: ROUTES.BUSINESS_SOLUTIONS, name: 'Business Solutions', title: 'HR & Business Solutions — Connect Source', isNavVisible: true },
  { path: ROUTES.ABOUT, name: 'About', title: 'About Us — Connect Source', isNavVisible: true },
  { path: ROUTES.FREE_INTERVIEW_GUIDE, name: 'Resources', title: 'Resources & Free Guide — Connect Source', isNavVisible: true },
  { path: ROUTES.CONTACT, name: 'Contact', title: 'Contact Us — Connect Source', isNavVisible: true },
  { path: ROUTES.PRODUCT_ATS_RESUME, name: 'ATS Resume Kit', title: 'ATS Resume Master Kit — Connect Source', isNavVisible: false },
  { path: ROUTES.PRODUCT_LINKEDIN, name: 'LinkedIn Toolkit', title: 'LinkedIn Profile Optimization Toolkit — Connect Source', isNavVisible: false },
  { path: ROUTES.PRODUCT_INTERVIEW_CRACKER, name: 'Interview Cracker Kit', title: 'Interview Cracker Kit (Job Search Edition) — Connect Source', isNavVisible: false },
  { path: ROUTES.PRODUCT_AI_TOOLKIT, name: 'AI Job Search Toolkit', title: 'AI Job Search Toolkit — Connect Source', isNavVisible: false },
  { path: ROUTES.PRODUCT_JOB_SWITCH, name: '30-Day Job Switch Blueprint', title: '30-Day Job Switch Blueprint — Connect Source', isNavVisible: false },
  { path: ROUTES.CHECKOUT, name: 'Checkout', title: 'Secure Checkout — Connect Source', isNavVisible: false },
  { path: ROUTES.THANK_YOU, name: 'Thank You', title: 'Thank You — Connect Source', isNavVisible: false },
  { path: ROUTES.PAYMENT_SUCCESS, name: 'Payment Success', title: 'Payment Confirmed — Connect Source', isNavVisible: false },
  { path: ROUTES.PAYMENT_FAILED, name: 'Payment Failed', title: 'Payment Incomplete — Connect Source', isNavVisible: false },
  { path: ROUTES.DOWNLOAD, name: 'Download Center', title: 'Digital Deliverable Download — Connect Source', isNavVisible: false },
  { path: ROUTES.PRIVACY_POLICY, name: 'Privacy Policy', title: 'Privacy Policy — Connect Source', isNavVisible: false },
  { path: ROUTES.TERMS, name: 'Terms of Service', title: 'Terms of Service — Connect Source', isNavVisible: false },
  { path: ROUTES.REFUND_POLICY, name: 'Refund Policy', title: 'Refund Policy — Connect Source', isNavVisible: false }
];

export const MAIN_NAV_ITEMS = ROUTE_DEFINITIONS.filter(r => r.isNavVisible);


